import { render, staticRenderFns } from "./liaTableComponent1.vue?vue&type=template&id=348cd577&scoped=true"
import script from "./liaTableComponent1.vue?vue&type=script&lang=js"
export * from "./liaTableComponent1.vue?vue&type=script&lang=js"
import style0 from "./liaTableComponent1.vue?vue&type=style&index=0&id=348cd577&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348cd577",
  null
  
)

export default component.exports